import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  TextField,
  Link,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import StarsSelectInput from "./fundamentals/StarsSelectInput";
import { CONTRACT_SENIORITY_LIST_TYPE_MAPPER, FTPT_FILTER } from "../util/constants";
import SlideUpTransition from "./fundamentals/SlideUpTransition";
import { sortOnCaseSensitiveTexts } from "../util/commonUtils";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontWeight: "bold",
    marginLeft: "15px",
  },
  button: {
    margin: "5px",
    width: "100px",
  },
  seniorityInput: {
    padding: "15px",
  },
  stationFilter: {
    width: "100%",
  },
}));

const SeniorityListFiltersDialog = (props) => {
  const classes = useStyles();
  const renderSeniorityListTypeItem = (seniorityListTypeString) => {
    return (
      <MenuItem key={seniorityListTypeString} value={seniorityListTypeString}>
        {seniorityListTypeString}
      </MenuItem>
    );
  };
  const handleCancelButtonClick = () => {
    props.setIsDialogOpen(false);
  };

  return (
    <Dialog
      fullScreen
      className="detail-dialog"
      fullWidth
      maxWidth="md"
      TransitionComponent={SlideUpTransition}
      open={props.isDialogOpen}
      onClose={handleCancelButtonClick}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle className={classes.dialogTitle} id="alert-dialog-slide-title">
        Filters
      </DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <div className={classes.seniorityInput}>
            {props?.stationList?.length > 1 ? (
              <StarsSelectInput
                label="Station"
                menuMessage="Station"
                value={props.station}
                fullWidth
                allOptions={props.stationList}
                sortComparator={sortOnCaseSensitiveTexts}
                onChange={props.handleStationChange}
                onBlur={props.handleStationBlur}
                errors={props.stationErrors}
                multiple={false}
              />
            ) : (
              <TextField
                fullWidth
                label="Station"
                variant="outlined"
                value={props.station}
                onChange={props.handleStationChange}
                onBlur={props.handleStationBlur}
                disabled
                error={props.stationErrors !== ""}
                helperText={props.stationErrors}
              />
            )}
          </div>
          <div className={classes.seniorityInput}>
            <TextField
              id="workgroupSelectElement"
              fullWidth
              label="Workgroup"
              variant="outlined"
              value={props.workgroup}
              disabled
              error={!!(props.workgroupErrors !== "")}
              helperText={props.workgroupErrors}
            />
          </div>
          <div className={classes.seniorityInput}>
            <FormControl variant="outlined" className={classes.selectInput} fullWidth>
              <InputLabel>Seniority List Type</InputLabel>
              <Select
                id="stationSelectElement"
                value={props.seniorityListType}
                onChange={props.handleSeniorityListTypeChange}
                label="Seniority List Type"
                disabled={!props.workgroup}
              >
                <MenuItem value="" disabled>
                  <em>Seniority List Type</em>
                </MenuItem>
                {props.contract !== "" &&
                  CONTRACT_SENIORITY_LIST_TYPE_MAPPER(props.contract, props.station)
                    .slice()
                    .sort()
                    .map((seniorityListType) => {
                      return renderSeniorityListTypeItem(seniorityListType);
                    })}
              </Select>
            </FormControl>
          </div>
          <div className={classes.seniorityInput}>
            <FormControl variant="outlined" className={classes.selectInput} fullWidth>
              <InputLabel>FT/PT</InputLabel>
              <Select
                id="stationSelectElement"
                value={props.filterSetting}
                onChange={(e) => props.handleFtPtFilterChange(e)}
                label="FT/PT"
              >
                <MenuItem value="" disabled>
                  <em>FT/PT</em>
                </MenuItem>
                {FTPT_FILTER.map((item, index) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </DialogContentText>
      </DialogContent>
      <Grid container justifyContent="center" sx={{ p: 4 }}>
        <Link component="button" variant="body2" onClick={props.handleResetClick}>
          <b>RESET FILTERS</b>
        </Link>
      </Grid>
      <DialogActions>
        <Grid container justifyContent="flex-end" alignItems={"center"} spacing={1}>
          <Grid item>
            <Button className={classes.button} variant="outlined" color="primary" onClick={handleCancelButtonClick}>
              CANCEL
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" onClick={props.handleApplyFilters}>
              Apply Filters
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

SeniorityListFiltersDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  handleApplyFilters: PropTypes.func.isRequired,
  handleResetClick: PropTypes.func.isRequired,
  handleFtPtFilterChange: PropTypes.func.isRequired,
  filterSetting: PropTypes.string.isRequired,
  station: PropTypes.string.isRequired,
  contract: PropTypes.string.isRequired,
  workgroup: PropTypes.string.isRequired,
  seniorityListType: PropTypes.string.isRequired,
  stationList: PropTypes.array.isRequired,
  handleStationChange: PropTypes.func.isRequired,
  handleStationBlur: PropTypes.func.isRequired,
  handleWorkgroupSelectBlur: PropTypes.func.isRequired,
  handleSeniorityListTypeChange: PropTypes.func.isRequired,
  stationErrors: PropTypes.string,
  workgroupErrors: PropTypes.string,
};

export default SeniorityListFiltersDialog;
